<template>
  <div class="item__head__icon" @click="handlePlayMedia(dataSource, position, isPlay)">
    <img v-if="dataSource.path && checkVideo(dataSource.path)" :src="getIcon('play', dataSource)" alt="Học liệu">
    <img v-else-if="dataSource.imageUrl || ( dataSource.linkUrl && checkGifImage(dataSource.linkUrl) )" :src="getIcon('gif', dataSource)" alt="Học liệu">
    <img v-else-if="dataSource.imageUrl || ( dataSource.linkUrl && checkImage(dataSource.linkUrl) )" :src="getIcon('image', dataSource)" alt="Học liệu">
    <img v-else-if="dataSource.linkUrl && checkVideo(dataSource.linkUrl)" :src="getIcon('play', dataSource)" alt="Học liệu">
    <!-- <template v-else-if="dataSource.linkUrl && checkAudio(dataSource.linkUrl)"> -->
      <!-- <img v-if="audioPause === position" :src="getIcon('pause')" class="media-audio" alt="Học liệu"> -->
    <img v-else-if="dataSource.linkUrl && checkAudio(dataSource.linkUrl) && audioPause !== position" :src="getIcon('play', dataSource)" class="media-audio" alt="Học liệu">


    <!-- </template> -->
    <!-- <span v-if="dataSource.imageUrl || ( dataSource.linkUrl && checkGifImage(dataSource.linkUrl) )" class="font-size-28" :class="`icon-gif${setTypeIcon(dataSource)}`"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span></span> -->
    <!-- <span v-else-if="dataSource.imageUrl || ( dataSource.linkUrl && checkImage(dataSource.linkUrl) )" class="font-size-28" :class="`icon-image${setTypeIcon(dataSource)}`"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> -->
    <!-- <span v-else-if="dataSource.linkUrl && checkVideo(dataSource.linkUrl)" class="font-size-28" :class="`icon-play${setTypeIcon(dataSource)}`"><span class="path1"></span><span class="path2"></span></span> -->
    <!-- <span v-else-if="dataSource.linkUrl && checkAudio(dataSource.linkUrl)" class="font-size-28" :class="`icon-audio${setTypeIcon(dataSource)}`"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> -->
    <!-- <span v-else-if="dataSource.linkUrl && checkAudio(dataSource.linkUrl)" class="font-size-28 media-audio" :class="`icon-play${setTypeIcon(dataSource)}`"><span class="path1"></span><span class="path2"></span></span> -->
  </div>
</template>

<script>
  import mixinsFiles from '@/components/content-files/mixinsFiles'

  export default {
    name: 'IconMedia',
    mixins: [ mixinsFiles ],
    props: {
      dataSource: Object,
      isPlay: Boolean,
      position: Number
    },
    data () {
      return {
        audioPause: -1
      }
    },
    methods: {
      setTypeIcon (val) {
        if ( (!val.isShowFree || val.isShowFree === 0) && !val.isActived ) {
          return '-3'
        } else if (!val.isPublish || val.isPublish === 0) {
          return '-2'
        } else {
          return ''
        }
      },

      getIcon (name, val = null) {
        let type = '';
        if ( val && (!val.isShowFree || val.isShowFree === 0) && !val.isActived ) {
          type = '-3'
        } else if ( val && (!val.isPublish || val.isPublish === 0) ) {
          type = '-2'
        }

        return require(`@/assets/images/linktypes/${name}${type}.svg`)
      },

      handlePlayMedia (val, position, isPlay = false) {
        // console.log('Media', val, position, isPlay);
        if (val.linkUrl && this.checkAudio(val.linkUrl) && isPlay) {
          let audioElm = document.getElementById(`audio_${position}`)
          if (audioElm) {
            if (this.audioPause === position) {
              audioElm.pause()
              this.audioPause = -1
            } else if ( this.audioPause > -1 ) {
              let audioPaying = document.getElementById(`audio_${this.audioPause}`)
              audioPaying.pause()
              audioElm.play()
              this.audioPause = position
            } else {
              audioElm.play()
              this.audioPause = position
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.clearfix:before, .clearfix:after {
  content: " ";
  display: table;
}
.clearfix:after {
  clear: both;
}
.item__head__icon {
  .media-audio {
    position: absolute;
    // left: 15px;
    left: 3%;
    // margin-top: -10px;
  }

  img {
    width: 26px;
  }
}
</style>